import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ErrorService } from '../../error';
import { QuoteModel, QuoteResponseModel } from './types';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class QuoteApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly errorService: ErrorService
  ) {}

  getById = (id: number): Observable<QuoteModel> => {
    let parameters: string[];
    parameters = [id.toString()];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<QuoteModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      })
    );
  };

  getComparatorQuotes = (id: string): Observable<QuoteResponseModel[]> => {
    let parameters: string[];
    parameters = ['comparator', id];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<QuoteResponseModel[]>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      })
    );
  };
  addQuotes = (quotes: QuoteModel[]): Observable<any> => {
    let parameters: string[];
    parameters = [];
    let url = this.formatUrl(parameters);
    return this.httpClient.post<any>(url, quotes).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      })
    );
  };

  formatUrl = (parameters: string[]): string => {
    var url = environment.comparanooapiurl;
    url += environment.features.quote.url;
    parameters.forEach((parameters) => {
      url += '/';
      url += parameters;
    });
    return url;
  };
}
